var _circle, _circle2, _circle3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHunter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 21,
    stroke: "currentColor",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 13,
    stroke: "currentColor",
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 3,
    stroke: "currentColor",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 11V21",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26 11V21",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.627 22.3574L21.1375 25.4476",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8633 18.5527L22.3738 21.6429",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4873 22.3574L26.9767 25.4476",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.251 18.5527L25.7404 21.6429",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2363 35.4414L24.1142 27.3512",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15 33.0898L20.8779 24.9997",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8779 35.4414L24.0001 27.3512",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1143 33.0898L27.2364 24.9997",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1679 6.5547C25.4743 7.01423 26.0952 7.1384 26.5547 6.83205C27.0142 6.5257 27.1384 5.90483 26.8321 5.4453L25.1679 6.5547ZM23.1679 3.5547L25.1679 6.5547L26.8321 5.4453L24.8321 2.4453L23.1679 3.5547Z",
    fill: "currentColor"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8321 41.4453C24.5257 40.9858 23.9048 40.8616 23.4453 41.1679C22.9858 41.4743 22.8616 42.0952 23.1679 42.5547L24.8321 41.4453ZM26.8321 44.4453L24.8321 41.4453L23.1679 42.5547L25.1679 45.5547L26.8321 44.4453Z",
    fill: "currentColor"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4453 24.1679C40.9858 24.4743 40.8616 25.0952 41.1679 25.5547C41.4743 26.0142 42.0952 26.1384 42.5547 25.8321L41.4453 24.1679ZM44.4453 22.1679L41.4453 24.1679L42.5547 25.8321L45.5547 23.8321L44.4453 22.1679Z",
    fill: "currentColor"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5547 23.8321C7.01423 23.5257 7.1384 22.9048 6.83205 22.4453C6.5257 21.9858 5.90483 21.8616 5.4453 22.1679L6.5547 23.8321ZM3.5547 25.8321L6.5547 23.8321L5.4453 22.1679L2.4453 24.1679L3.5547 25.8321Z",
    fill: "currentColor"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2172 36.4549C35.6757 36.3466 35.1488 36.6978 35.0405 37.2394C34.9322 37.7809 35.2834 38.3077 35.825 38.4161L36.2172 36.4549ZM39.7528 37.162L36.2172 36.4549L35.825 38.4161L39.3605 39.1232L39.7528 37.162Z",
    fill: "currentColor"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7838 11.5461C12.3253 11.6544 12.8521 11.3032 12.9605 10.7616C13.0688 10.2201 12.7175 9.69324 12.176 9.58492L11.7838 11.5461ZM8.24822 10.839L11.7838 11.5461L12.176 9.58492L8.64045 8.87782L8.24822 10.839Z",
    fill: "currentColor"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5461 36.2172C11.6544 35.6757 11.3032 35.1488 10.7616 35.0405C10.2201 34.9322 9.69324 35.2834 9.58492 35.825L11.5461 36.2172ZM10.839 39.7528L11.5461 36.2172L9.58492 35.825L8.87782 39.3605L10.839 39.7528Z",
    fill: "currentColor"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4549 11.7838C36.3466 12.3253 36.6978 12.8521 37.2394 12.9605C37.7809 13.0688 38.3077 12.7175 38.4161 12.176L36.4549 11.7838ZM37.162 8.24822L36.4549 11.7838L38.4161 12.176L39.1232 8.64045L37.162 8.24822Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHunter);
export default __webpack_public_path__ + "static/media/Hunter.17b7f8d7.svg";
export { ForwardRef as ReactComponent };